import { useQuery } from "@tanstack/react-query";

import getQueryKeys from "common/datahooks/getQueryKeys";
import { useCampaignContext } from "common/helpers/CampaignContext";
import { get } from "common/helpers/HTTP";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";

import type { AudienceStats } from "../types";

async function getAudienceStatsRequest(
  workspaceId: string,
  campaignId: string,
): Promise<AudienceStats> {
  return (
    await get(
      `workspaces/${workspaceId}/campaigns/${campaignId}/audience-stats`,
    )
  ).stats;
}

export default function useAudienceStats() {
  const { id: campaignId } = useCampaignContext();
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { campaignsKeys } = getQueryKeys(workspaceId);

  const {
    data: audienceStats,
    isLoading: isLoadingAudienceStats,
    isError: isAudienceStatsError,
    refetch: refetchAudienceStats,
  } = useQuery({
    queryKey: campaignsKeys.audienceStats(campaignId),
    queryFn: () => getAudienceStatsRequest(workspaceId, campaignId),
  });

  return {
    audienceStats,
    isLoadingAudienceStats,
    isAudienceStatsError,
    refetchAudienceStats,
  };
}
